import { createStore } from './createStore';

const ticketDetailsConversationStore = {
  id: 'ticketDetailsConversationStore',
  initialState: {
    activeTabIndex: 0,
    conversationMode: null,
    editNoteData: null,
    editNotePrivacyType: null,
    defaultReplyTemplate: null,
    isConversationSentFromTriageAgent: false,
    triageContent: null,
    newSideConversationLoading: false,
    ticketDescription: null
  },
  methods: (set, get) => ({
    setActiveTabIndex: (activeIndex) => {
      set({ activeTabIndex: activeIndex });
    },
    setConversationMode: (mode) => {
      set({ conversationMode: mode });
    },

    setEditNoteData: (editNoteData) => {
      set({ editNoteData: editNoteData });
    },

    setEditNotePrivacyType: (privacyType) => {
      set({ editNotePrivacyType: privacyType });
    },
    setTriageContent: (content) => {
      set({ triageContent: content });
    },
    setNewSideConversationLoading: (loading) => {
      set({ newSideConversationLoading: loading });
    },
    resetEditNote: () => {
      set({
        editNoteData: null,
        editNotePrivacyType: null
      });
    },
    setDefaultReplyTemplate: (template) => {
      set({ defaultReplyTemplate: template });
    },
    setIsConversationSentFromTriageAgent: (bool) => {
      set({ isConversationSentFromTriageAgent: bool });
    },
    setTicketDescription: (description) => {
      set({ ticketDescription: description });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useTicketDetailsConversationStore = createStore(
  ticketDetailsConversationStore
);
